export default {
  'magazine:breadcrumb:magazine': 'Magazine',
  'magazine:top-page:title': 'Pets Deli Magazine',
  'magazine:top-page:subtitle':
    'Ontdek onze onderwerpen over de voeding, gezondheid en opvoeding van honden en katten.',
  'magazine:top-page:in-focus': 'Actuele onderwerpen',
  'magazine:top-page:main-theme': 'Populaire categorieën',
  'magazine:top-page:top-articles': 'Onze artikelen',
  'magazine:author-page:title': 'Nieuwste artikelen van {name}',
  'magazine:article-page:section-cta:default-title': 'Lees ook',
  'magazine:article-page:table-of-contents': 'Inhoudsopgave',
};
